<div class="temperature">
    <mat-icon [ngClass]="action.from">{{GLOBAL.ICONS.PROJECT}}</mat-icon>
    <mat-icon>east</mat-icon>
    <mat-icon [ngClass]="action.to">{{GLOBAL.ICONS.PROJECT}}</mat-icon>
</div>